<template>
  <button class="btn btn-orange" @click="submit">
    <slot>  
      <span>Load More</span>
    </slot>
    <span v-if="loading" class="rml50">
      <i class="fas fa-spinner rotate" ></i>
    </span>
  </button>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    submit() {
      this.$emit('submit')
    }
  },
};
</script>

<style lang="scss" scoped>

.rotate {
  -webkit-animation: rotation 2s infinite linear;
}

@-webkit-keyframes rotation {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(359deg);
  }
}
</style>
